<template>
    <div class="home">
        <!-- banner -->
        <el-carousel class="banner">
            <el-carousel-item v-for="(item, index) in banner" :key="index">
                <img class='banner-img' :src="item.litpic" alt="">
            </el-carousel-item>
        </el-carousel>

        <!-- 内容盒子 -->
        <div class="type_area">
            <!-- 标题  -->
            <div class="title">
                <img src="../assets/images/home/title.png" alt="">
            </div>

            <!-- 内容 -->
            <div class="content">
                <div v-for='(item,index) in home' :key='index' class="product col-xs-6 col-sm-3" @click="skip(item.id)">
                    <img :src='item.typeimg' alt="">
                    <p>{{item.typename}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constants } from 'crypto';



    export default {
        name: 'home',
        data:function() {
            return {
                startX:0,
                moveEndX:0,
                X:0,
                home:[],
                banner:[{litpic:"../assets/images/home/banner.png"}],
            };
        },
        methods:{
            skip(e){
                this.$router.push({ path:'/classify'+'?id='+e})
            },
            slide(){
                var _this=this
                // 左右滑动事件
                $("#el_carousel").on("touchstart", function (e) {
                    _this.startX = e.originalEvent.changedTouches[0].pageX;
                });
                $("#el_carousel").on("touchend", function (e) {
                    _this.moveEndX = e.originalEvent.changedTouches[0].pageX;
                    _this.X = _this.moveEndX - _this.startX;
                    if(_this.X>0){
                        // console.log('左滑')
                        _this.$refs.carousel.prev()
                    }
                    if(_this.X<0){
                        // console.log('右滑')
                        _this.$refs.carousel.next()
                    }
                })
            },
        },
        components: {

        },
        mounted() {
            this.$http.get("/api/banner.php").then((res)=>{
                this.banner = res.data.data;
                setTimeout(this.slide, 100)
            });
            this.$http.get("/api/home.php").then((res)=>{
                this.home = res.data.data;
                console.log(this.home)
            })
        }
    }
</script>


<style lang="less">
    .home{
        margin:3rem 0 0;
        background:#F0F2F5;
        min-height: 45.5rem;
        // banner
        .banner{
            /*width:100%;*/
            /*height: 160px;*/
        }
        // 标题
        .title{
            display:flex;
            justify-content: center;
            margin: 1rem 0;
            img{
                height:2.5rem;
            }
        }
        // 内容
        .content{
            display:flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .product{
                width:13rem;
                height:13rem;
                margin-bottom: 2rem;
                padding: 0;
                display:flex;
                flex-wrap: wrap;
                justify-content: center;
                overflow: hidden;

                img{
                    height:90%;
                }
                p{
                    width:100%;
                    text-align: center;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    padding: 0 1rem;
                    position:absolute;
                    bottom:-3px;
                }
            }
        }
    }
    .banner-img {
        height: 100%;
    }
</style>
